import { LoanRequestDetailsComponent } from 'src/app/LoanRequest/loan-request-details/loan-request-details.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { CompanyAccess } from 'src/model/companyAccess.model';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { LoanGroupRequest } from 'src/model/sharedLoan.model';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { CustomerAccountService } from 'src/services/customer-account.service';

@Component({
    selector: 'app-bookmark-item',
    imports: [CommonModule, NgbPopoverModule],
    templateUrl: './bookmark-item.component.html',
    styleUrl: './bookmark-item.component.scss'
})
export class BookmarkItemComponent {
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private router = inject(Router);
  private custAccountService = inject(CustomerAccountService);

  @Input() adminAccess: Record<string, CompanyAccess[]> = {};
  @Input() bookmarkGroup: LoanGroupRequest[] = [];
  @Input() approvedAccountList: AccountAuthorization[] = [];
  @Input() pendingAccountList: AccountAuthorization[] = [];

  @Output() itemRemoved = new EventEmitter<number | number[]>();
  status: boolean = undefined;

  getStatus(requestList: LoanRequest[]): boolean {
    let result: boolean = undefined;
    if (requestList.every(o => o.Approved === true))
      result = true;
    else if (requestList.some(o => o.Approved === false))
      result = false;
    return result;
  }

  removeBookmarks(requestGroup: LoanGroupRequest) {
    this.itemRemoved.emit(requestGroup.requestList.map(r => r.ID));
  }

  goToCustomer(custId, profileId: string) {
    this.router.navigate(['/manageCustomer', custId, profileId]);
  }

  getTotalOnHand(loanGroup: LoanGroupRequest) {
    return loanGroup.requestList.reduce((total, l) => total + this.sharedService.calculateTotalOnHand(l.LoanInfo), 0)
  }

  ticketDateWarning(aDate: Date, limit: number): boolean {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const diffInTime = (new Date()).getTime() - (new Date(aDate)).getTime();
    return (Math.round(diffInTime / oneDay) >= limit);
  }

  openLoanRequestModal(req: LoanRequest | LoanRequest[]) {
    if (Array.isArray(req)) {
      if (req.length === 1) this.openLoanRequestModal(req[0]);
    } else {
      const modalRef = this.sharedService.openModal(LoanRequestDetailsComponent, 'largeModal');
      modalRef.componentInstance.request = req;
      modalRef.componentInstance.viewOnly = true;
      modalRef.componentInstance.isModal = true;
    }
  }

  async openViewFilesModal(account: CustomerAccount) {
    const files = await this.custAccountService.getCustomerAccountFiles(account.CustomerId, account.Id);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'regularModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
  }
}
